import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import ScrollButton from '../ScrollButton';
import { CDN_URL } from '../../constants';

const Trustees = ({ image, items, ...rest }) => {
  const hasItems = !!items?.length;

  if (!hasItems) {
    return null;
  }

  return (
    <div className='trustees' {...rest}>
      <div className='trustees__container'>
        {image && (
          <div className='trustees__image' style={{ backgroundImage: `url(${CDN_URL}${image})` }} />
        )}
        <div className='container'>
          <div className='row'>
            <div className='col'>
              <div className='trustees__content'>
                {items.map((item, itemIndex) => {
                  const hasPeople = !!item?.people?.length;

                  if (!hasPeople) {
                    return null;
                  }

                  return (
                    <div
                      className={classnames('trustees__block', `trustees__block--${itemIndex}`)}
                      key={`trustees__block-${itemIndex}`}
                    >
                      {item.title && <div className='trustees__title'>{item.title}</div>}
                      <ul className='trustees__list'>
                        {item.people.map((person, personIndex) => {
                          return (
                            <li
                              className='trustees__list-item'
                              key={`trustees__list-item-${itemIndex}-${personIndex}`}
                            >
                              {person.roles && (
                                <div>
                                  <strong>{person.roles}</strong>
                                </div>
                              )}
                              {person.name && <div>{person.name}</div>}
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  );
                })}

                <div className='trustees__cta'>
                  <ScrollButton href='#back-cover' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Trustees.propTypes = {
  image: PropTypes.string,
  items: PropTypes.array,
};

export default Trustees;
